module.exports = __webpack_public_path__ + "img/20240522145255422g77.7613b9bc.jpg";